import { AbstractControl, ValidatorFn } from '@angular/forms';
import { SnackBarService } from './util.SnackBarService';
import { Injectable } from '@angular/core';
interface FormType {
  parentesco: {
    value: string;
    messages: string;
    required: boolean;
  };
  campaniaContratante: {
    value: string;
    messages: string;
  };
  nombre: {
    value: string;
    messages: string;
    required: boolean;
    min: boolean;
    max: boolean;
  };
  nombreSegundo: {
    value: string;
    messages: string;
    required: boolean;
    min: boolean;
    max: boolean;
  };
  apellido: {
    value: string;
    messages: string;
    required: boolean;
    min: boolean;
    max: boolean;
  };
  apellidoSegundo: {
    value: string;
    messages: string;
    required: boolean;
    min: boolean;
    max: boolean;
  };
  genero: {
    value: string;
    messages: string;
    required: boolean;
  };
  fechaNacimiento: {
    value: string;
    messages: string;
    required: boolean;
  };
  contratanteTarifa: {
    value: string;
    messages: string;
    required: boolean;
  };
  tarifaInclusion: {
    value: string;
    messages: string;
    required: boolean;
  };
  position: {
    value: number;
    messages: string;
    required: boolean;
  };
}
@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  
  static calculateAge(value: Date | null) {
    throw new Error('Method not implemented.');
  }

  constructor(private snackBarService: SnackBarService) {
  }

  validateEmptyFields(form: any, snackBar = true, mensaje = '') {
    const response = { success: true, data: { ...form } };
    
    for (const key in form) {
      if (form.hasOwnProperty(key)) {
        if (form[key].required) {
          if (String(form[key].value).trim() === '' || form[key].value === null) {
            form[key].messages = mensaje == '' ? 'Este campo es requerido.' : mensaje;
            response.success = false;
          } else {
            form[key].messages = null;
          }
          
          if (form[key].min) {
            if (form[key].value) {
              if (form[key].value.length < 3) {
                form[key].messages = 'El mínimo de caracteres es 3'
                response.success = false;
              } else {
                form[key].messages = null;
              }
            }
          }
          
          if (form[key].max) {
            if (form[key].value) {
              if (form[key].value.length > 25) {
                form[key].messages = 'El máximo de caracteres es 25'
                response.success = false;
              } else {
                form[key].messages = null;
              }
            }
          }
        }
      }
    }
  
    if (snackBar && !response.success) {
      this.snackBarService.alert('alert-danger', 'Faltan campos por diligenciar.');
    }
  
    response.data = form;
    return response;
  }
  

  validateMsg(error: string) {
    this.snackBarService.alert('alert-danger', error);
  }

  validateForm(form: any, snackBar = true, mensaje = '') {
    const response = { success: true, data: null };
    for (const key in form.controls) {
      if (form.controls.hasOwnProperty(key)) {
        if (form.controls[key].status == "INVALID") {
          response.success = false;
        }
      }
    }
    if (snackBar && !response.success) {
      this.snackBarService.alert('alert-danger', 'Faltan campos por diligenciar.');
    }
    response.data = form;
    return response;
  }

  validateACompleteField(form: any, snackBar = true) {
    const response = { success: false, data: null };
    for (const key in form) {
      if (form.hasOwnProperty(key)) {
        if (String(form[key].value).trim() !== '' && form[key].value !== null) {
          response.success = true;
          break;
        }
      }
    }

    if (snackBar && !response.success) {
      this.snackBarService.alert('alert-danger', 'Ingrese al menos un valor en cualquiera de los campos para realizar la consulta.', 5000)
    }

    response.data = form;
    return response;
  }

  cleanFields(form: any) {
    for (const key in form) {
      if (form.hasOwnProperty(key)) {
        form[key].value = null;
        form[key].messages = null;
      }
    }
    return form;
  }

  calculateAge(date: any) {
    if (!date) {
        console.error("Fecha inválida:", date);
        return -1;  // O lanza una excepción si prefieres
    }

    // Si date es un objeto Date
    if (date instanceof Date) {
        const now = new Date();
        let birthAge = now.getFullYear() - date.getFullYear();
        const mes = now.getMonth() - date.getMonth();
        if (mes < 0 || (mes === 0 && now.getDate() < date.getDate())) birthAge--;
        return birthAge >= 0 ? birthAge : -1;
    }

    // Si date es un objeto con la estructura esperada
    if (date._i && date._i.year !== undefined && date._i.month !== undefined && date._i.date !== undefined) {
        const now = new Date();
        const dataBirthe = new Date(`${date._i.year}-${parseInt(date._i.month) + 1}-${date._i.date}`);
        let birthAge = now.getFullYear() - dataBirthe.getFullYear();
        const mes = now.getMonth() - dataBirthe.getMonth();
        if (mes < 0 || (mes === 0 && now.getDate() < dataBirthe.getDate())) birthAge--;
        return birthAge >= 0 ? birthAge : -1;
    }

    console.error("Estructura de fecha no válida:", date);
    return -1;  // O lanza una excepción si prefieres
  }

  emailValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const correo: string = control.value;
      const esValido = emailPattern.test(correo);
      return esValido ? null : { 'correoInvalido': { value: correo } };
    };
  }
}